const SIZE = 7;

function handleScroll (e) {
  const { target: $el } = e;
  const { scrollTop, scrollHeight, offsetHeight } = $el;

  const topShadow = scrollTop > 10 && `${ SIZE }px`;
  const botShadow = scrollTop < scrollHeight - offsetHeight - 10 && `-${ SIZE }px`;

  // $el.style.boxShadow = [topShadow, botShadow].filter(Boolean).join(', ');
  $el.style.boxShadow = `0 ${ topShadow || 0 } 5px -7px #d9d9d9 inset`
    + `, 0 ${ botShadow || 0 } 5px -7px #d9d9d9 inset`;
}

export default {
  mounted ($el) {
    $el.addEventListener('scroll', handleScroll, false);
    handleScroll({ target: $el });

    const { transition, willChange } = getComputedStyle($el);
    $el.style.transition = `${ transition ? transition + ',' : '' } box-shadow .3s`;
    $el.style.willChange = `${ willChange ? willChange + ',' : '' } box-shadow`;
  },

  unmounted ($el) {
    $el.removeEventListener('scroll', handleScroll, false);
  },
};
